import Vue from "vue";
import VueRouter from "vue-router";
import store from "@/store";
import { auth } from "@/firebase";
import ClientsDashboard from "@/views/Clients";
import DomainsDashboard from "@/views/Domains";
import ClientDetail from "@/views/ClientDetail";
import Home from "@/views/Home.vue";
import Login from "@/views/Login.vue";
import Proposals from "@/views/Proposals.vue";
import MonthlyExpenses from "@/views/MonthlyExpenses.vue";

auth.onAuthStateChanged(user => {
  store.commit("SET_USER", user);
});

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "home",
    component: Home,
    meta: {
      auth: true
    }
  },
  {
    path: "/login",
    name: "login",
    component: Login
  },
  {
    path: "/clients",
    name: "clientsdashboard",
    component: ClientsDashboard,
    meta: {
      auth: true
    }
  },
  {
    path: "/clients/:id",
    name: "clientprofile",
    component: ClientDetail,
    props: true,
    meta: {
      auth: true
    }
  },
  {
    path: "/domains",
    name: "domainsdashboard",
    component: DomainsDashboard,
    meta: {
      auth: true
    }
  },
  {
    path: "/monthlyexpenses",
    name: "monthlyexpenses",
    component: MonthlyExpenses,
    meta: {
      auth: true
    }
  },
  {
    path: "/proposals",
    name: "proposals",
    component: Proposals,
    meta: {
      auth: true
    }
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.auth)) {
    auth.onAuthStateChanged(function(user) {
      if (!user) {
        next({
          path: "/login"
        });
      } else {
        next();
      }
    });
  } else {
    next();
  }
});

export default router;
